
<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="entry.itemId"
          v-bind="getObject('itemId')"
          label="Item"
          :items="purchaseItemsList"
          item-value="id"
          item-text="name"
          :search-input.sync="itemsSearch"
          no-filter
          no-data-text="Nenhum Item encontrado, faça outra busca"
          :hint="purchaseItemAdditionalInfo(entry.item)"
          @input="selectItem"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>{{purchaseItemAdditionalInfo(data.item)}} </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>

        <v-card v-for="item in this.entry.weights" class="my-custom-card">
          <v-row>

            <v-col cols="12" md="4">
              <v-text-field
              v-model="item.packaging.name"
              v-bind="getObject('item.packaging.name')"
              label="Nome embalagem"
              autocomplete="off"
              :disabled="true"
              />
            </v-col>

            <v-col cols="12" md="4">
              <MaskedTextField
              mask-type="12v0-4"
              :inputData.sync="item.grossWeight"
              v-bind="getObject('grossWeight')"
              label="Peso bruto"
              autocomplete="off"
              />
            </v-col>
            
            <v-col cols="12" md="4">
              <MaskedTextField
              mask-type="12v0-4"
              :inputData.sync="item.liquidWeight"
              v-bind="getObject('liquidWeight')"
              label="Peso liquido"
              autocomplete="off"
              />
            </v-col>
            
          </v-row>
      </v-card>

      </v-col>

      
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"
import Masked_text_field from "../../shared/masked_text_field.vue";
// import NewItemSelect from " /new_item_select.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      purchaseItemsList: [],
      purchaseItemsListLoading: false,
      itemsSearch: "",
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    // NewItemSelect: NewItemSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // if(this.entry.item && this.entry.item.name){
    //   this.searchInput = this.entry.item.name;
    // }
    if(this.entry.itemId){
      // console.log(this.entry);
      this.purchaseItemsList.push(this.entry.item);
      this.selectItem();
    }
  },
  mounted() {
    // if (this.entry.unitId) {
    //   this.getPackagingsForUnit(false);
    // }
    
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log(newSearch, newSearch, oldSearch, oldSearch)
      if (this.itemsSearch && this.itemsSearch.length > 0) {
        if ((!this.entry.item || this.entry.item.name != this.itemsSearch) && newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log(newSearch, newSearch);
            this.getPurchaseItems();
          }, 1000);
        }
      }
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    selectItem: function() {
      // this.entry.item = this.extraData.accountContext.availableItemsForSale.find(obj => obj.id == this.entry.itemId);
      // this.packagingsList = [];

      // console.log("selectItem");
      this.entry.weights = [];

      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_WEIGHTS_FOR_ITEM_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            itemId: this.entry.itemId,
          }
        })
        .then(response => {
          console.log("response dos item", response);
          // while(this.weights.length>0) {
          //   this.weights.pop();
          // }
          var resp = response.data.accountContext.availableItemWeights;
          // for(var r of resp){
          //   this.weights.push(r);
          // }
          this.entry.weights = resp;
          // let clearStorage = false;
          // if (this.packagingList.length == 1 && !this.entry.packagingId) {
          //   this.entry.packagingId = this.packagingList[0].id;
          //   clearStorage = clearPackagingAndStorage;
          // }
          // this.selectPackagingInStorage(clearStorage);
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingsListLoading = false));
    },
    purchaseItemAdditionalInfo: function(item) {
      let info = ""
      if (item) {
        info = 'Unidade de Compra: ' + item.unit.name + (item.brand ? ', Marca: ' + item.brand.name : '') + (item.typeText ? ', Tipo: ' + item.typeText : '') + ", Conta: "+ item.account.name
      }
      return info;
    },
    getPurchaseItems: function() {
      this.purchaseItemsListLoading = true;
      this.$apollo
        .query({
          query: ITEMS_FOR_PURCHASE_QUERY,
          variables: {
            query: this.itemsSearch
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("getPurchaseItems", response.data.accountGlobalSharedContext.allAvailableItemsSearch);
          // response.data.accountGlobalSharedContext.allAvailableItemsSearch
          this.purchaseItemsList = response.data.accountGlobalSharedContext.allAvailableItemsSearch;
          // console.log("getPurchaseItems", this.purchaseItemsList);
          // if (this.packageList.length == 1 && !this.entry.packageId) {
          //   this.entry.packageId = this.packageList[0].id;
          //   this.selectPackage();
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.purchaseItemsListLoading = false));
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },      
    cultureCreated: function(culture) {
      this.extraData.adminContext.allCultures.unshift(culture);
      this.entry.cultureId = culture.id;
      this.entry.culture = culture;
    },
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsSearch(query: $query) {
        id
        description
        name
        unit {
          name
        }
        brand {
          name
        }
        account{
          name
        }
        typeText
      }
    }
  }
`;

const AVAILABLE_WEIGHTS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountContext {
      availableItemWeights(itemId: $itemId){
        id
        itemId
        packagingId
        packaging{
          name
          size
        }
        grossWeight
        liquidWeight
      }
    }
  }
`;
</script>

<style scoped>
.my-custom-card {
      background-color: #aaffaa;
      border: 1px solid #ccc;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      margin-bottom: 10px;
      padding: 8px;
    }
</style>


